'use strict';
const angular = require('angular');

export class assetUploadComponent {
  /*@ngInject*/
  constructor(Upload,Auth) {
    this.Upload = Upload;
    this.Auth = Auth;
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.storageIds});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isHtmlMime(mime) {
    return mime == 'text/html';
  }

  isWordMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      mime == 'application/msword';
  }

  isPowerPointMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
      mime == 'application/vnd.ms-powerpoint';
  }

  isExcelMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  isOpenDocumentPresentation(mime) {
    return mime == 'application/vnd.oasis.opendocument.presentation';
  }

  isOpenDocumentText(mime) {
    return mime == 'application/vnd.oasis.opendocument.text';
  }

  isOpenDocumentSpreadsheet(mime) {
    return mime == 'application/vnd.oasis.opendocument.spreadsheet';
  }

  getIconByMime(mime) {
    if (this.isImageMime(mime))
      return "fa-file-image-o";
    else if (this.isPdfMime(mime))
      return "fa-file-pdf-o";
    else if (this.isHtmlMime(mime))
      return "fa-file-code-o";
    else if (this.isWordMime(mime))
      return "fa-file-word-o";
    else if (this.isOpenDocumentText(mime))
      return "fa-file-word-o";
    else if (this.isExcelMime(mime))
      return "fa-file-excel-o";
    else if (this.isOpenDocumentSpreadsheet(mime))
      return "fa-file-excel-o";
    else if (this.isPowerPointMime(mime))
      return "fa-file-powerpoint-o";
    else if (this.isOpenDocumentPresentation(mime))
      return "fa-file-powerpoint-o";
    else
      return "fa-file-o";
  }

  selectFiles(files) {
    this.files = files;

    this.files.forEach(file => {
      file.isPublic = false;
      file.permission = ["user"];
    });
  }

  uploadFiles() {
    let files = this.files;

    this.storageIds = [];
    this.allDone = false;
    this.progress = 0;

    var that = this;

    if (files && files.length) {

      var count = 0;

      files.forEach(file => {

        let permission = file.permission || [];

        this.Upload.upload({
          url: '/api/storage',
          data: {
            name: file.name,
            file: file,
            isPublic: file.isPublic,
            permission: permission.join(','),
            storageStrategy: 'local',
            creationUser: this.Auth.getCurrentUserSync()._id,
            active: true
          }
        }).then(function (response) {
          that.storageIds.push(response.data);

          count++;

          that.progress = Math.floor(count / files.length) * 100;

          if (count === files.length) {
            that.allDone = true;
            that.progress = 100;

            that.ok();
          }

        }, function (response) {
          if (response.status > 0) {
            alert(response.status + ': ' + response.data);
          }
        });

      });

    }
  };

}

export default angular.module('conduu.sm.asset.upload', [])
  .component('assetUpload', {
    template: require('./asset-upload.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: assetUploadComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/asset-upload/asset-upload.component.js